module.exports = __webpack_public_path__ + "media/images/sp/stores/common/instagram/hairmake_sns_05-6c8e1c6456eaeee81800c22b5fd31576.jpg";